<template>
	<div class="top">
		<div style="width: 200px;height: 20px;">
		</div>
		<div v-for="(item , index) of titleList" :key="index">
			<!--:class="[ item.Nodes && !item.Checked ? 'avcites-bg' : '' ]"-->
			<div v-if="titleList[0].Nodes[0].Path.indexOf('/') != -1" class="title-list avcites-bg"
				@click="titlelistchildrenclick(index , item.Path , titleList[index].Nodes)">
				<div class="avcite-left" style=""></div>
				<span>{{ item.NodeName }}</span>
				<div style="display: inline-block;position: absolute;margin-left: 180px;"
					:class="[ item.Checked ?  'avcitets' : 'avcites' ]" v-if="item.Nodes"
					@click="titlelistchildrenclick(index , item.Path , titleList[index].Nodes)">
					<img src="../assets/icon/upleft.png" alt="" style="width: 16px;height: 16px;">
				</div>
			</div>
			<div v-else class="title-list" :class="[{ 'avcite' : item.NodeID  == onchage }]"
				@click="titlelistclick(index , item.NodeID ,  item.Path , titleList[index].Nodes)">
				<div class="avcite-left" style=""></div>
				<span>{{ item.NodeName }}</span>
			</div>
			<collapse-transition>
				<div v-if="item.Checked">
					<div v-for="(items , indexs) of item.Nodes" :key="indexs">
						<div class="title-lists" :class="[{ 'avcite' : items.NodeID == onchages }]"
							@click="titlelistclickss(items.NodeID , items.Path , items.Nodes)">
							<div class="avcite-left" style=""></div>
							<span>{{ items.NodeName }}</span>
						</div>
					</div>
				</div>
			</collapse-transition>
		</div>
		<div style="width: 200px;height: 30px;">
		</div>
	</div>
</template>

<script src="https://cdn.jsdelivr.net/npm/vue@2.5.16/dist/vue.js"></script>
<script>
	import CollapseTransition from '../common/transition'
	export default {
		components: {
			'collapse-transition': CollapseTransition
		},
		props: {
			titleList: []
		},
		data() {
			return {
				onchage: null, //左侧菜单栏状态
				onchages: null, //子菜单状态
				childrenboo: false,
			}
		},
		created() {},
		mounted() {
			// if (sessionStorage.getItem("ischages") >= this.titleList.length) {
			//   this.onchage = sessionStorage.getItem("ischages")
			//   this.onchages = sessionStorage.getItem("ischagess")
			//   return
			// } else {
			//   this.onchage = sessionStorage.getItem("ischages")
			//   this.onchages = sessionStorage.getItem("ischagess")
			// }

		},
		methods: {
			titlelistclick(index, NodeID, router, Nodes) {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				setTimeout(() => {
					loading.close();
				}, 500);
				if (NodeID != this.onchage) {
					this.onchage = NodeID
				}
				this.$router.push({
					path: router,
					params: {
						Nodes: Nodes
					}
				})
			},
			titlelistclickss(NodeID, router, Nodes) {
				if (NodeID != this.onchages) {
					this.onchages = NodeID

				}
				this.$router.push({
					path: router,
					params: {
						Nodes: Nodes
					}
				})
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				setTimeout(() => {
					loading.close();
				}, 500);
			},
			titlelistchildrenclick(index) {
				this.titleList[index].Checked = !this.titleList[index].Checked
			},

		},
		watch: {
			"$route": {
				handler(to, from) {
					const Menus = JSON.parse(localStorage.getItem("MenusData"))
					let obj = null
					let MenusArr = []
					Menus.Menus.map((item, index) => {
						if (item.Nodes != null) {
							item.Nodes.map((items, indexs) => {
								obj = {
									ID: items.NodeID,
									path: items.Path
								}
								MenusArr.push(obj)
								if (items.Nodes != null) {
									items.Nodes.map((itemts, indexts) => {
										obj = {
											ID: itemts.NodeID,
											path: itemts.Path
										}
										MenusArr.push(obj)
									})
								}
							})
						}
					})
					this.onchages = to.query.MenuID
					this.onchage = to.query.MenuID
					console.log(this.onchages, ' this.onchages');
					console.log(this.onchage, ' this.onchage');
				},
				deep: true,
				immediate: true
			}
		}
	}
</script>
<style scoped lang="less">
	@import "../style/mixin.less";

	.top {
		user-select: none;

	}

	.avcite {
		background-color: #fce8ec;
		color: #e71d43;

		img {
			transform: rotate(180deg);
			transition: all 0.5s;
		}

		.avcite-left {
			width: 4px;
			// height: 100%;
			background-color: #e71d43;
			transition: all linear 0.8s;
		}
	}

	.avcitets {
		img {
			transform: rotate(180deg);
			transition: all 0.5s;
		}
	}

	.avcite-left {
		width: 4px;
		height: 100%;
	}

	.avcites {
		img {
			transform: rotate(0deg);
			transition: all 0.5s;
		}
	}

	.title-lists {
		width: 210px;
		height: 44px;
		font-size: 14px;
		line-height: 44px;
		margin-top: 8px;
		cursor: pointer;
		// overflow: hidden;
		display: flex;
		transition: all linear 0.5s;

		span {
			margin-left: 33px;
		}
	}

	.lefts {
		background-color: #fff;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);

		.title-list {
			width: 210px;
			height: 44px;
			font-size: 14px;
			line-height: 44px;
			margin-top: 8px;
			cursor: pointer;
			// overflow: hidden;
			display: flex;
			transition: all linear 0.5s;

			span {
				margin-left: 20px;
			}
		}

		.avcites-bg {
			background-color: #E6EAF2;
		}

		.title-list:hover {
			background-color: #fce8ec;
			transition: all linear 0.5s;
		}

		.avcites-bg:hover {
			background-color: #E6EAF2;
		}
	}

	.title-lists:hover {
		background-color: #fce8ec;
		transition: all linear 0.5s;
	}

	.cc {}

	@keyframes shows {
		0% {
			height: 0px;
		}

		100% {
			height: 202px;
		}
	}

	@keyframes hides {
		0% {
			height: 202px;
		}

		100% {
			height: 0px;
		}
	}
</style>